(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("contactPreferences", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/general/contactPreferences/contactPreferencesView.html",
            controller: ["tenantResource", "notify", "REG_EXP", ContactPreferencesCtrl],
            controllerAs: "vm"
        };
        function ContactPreferencesCtrl(tenantResource, notify, REG_EXP) {
            var vm = this;
            vm.loading = true;
            vm.saving = false;
            vm.showErrors = false;
            vm.emailPattern = REG_EXP.email;
            vm.phonePattern = REG_EXP.phone;
            vm.editEmail = false;
            vm.editPhone = false;
            vm.editSms = false;
            vm.formData = {
                contactViaPhone: false,
                contactViaTextMessages: false
            };
            tenantResource.getContactPreferences(function (result) {
                vm.formData = result;
                vm.loading = false;
            });
            vm.save = function () {
                vm.showErrors = true;
                if (vm.form.$valid) {
                    vm.saving = true;
                    tenantResource.saveContactPreferences(vm.formData, function (result) {
                        vm.editEmail = false;
                        vm.editPhone = false;
                        vm.editSms = false;
                        vm.formData = result;
                        notify({ messageTemplate: "<span translate='settings.general.contactPreferences.saveMessage'></span>", classes: "alert-success" });
                        vm.saving = false;
                    }, function () {
                        vm.editEmail = false;
                        vm.editPhone = false;
                        vm.editSms = false;
                        notify({ messageTemplate: "<span>{{ 'common.genericError' | translate }}</span>", classes: "alert-danger" });
                    });
                }
            };
        }
    });
}());
